<section id="history" class="page-banner parallax-section">
    <div class="container-fluid text-center">
        <div class="row">
            <!-- <div class=" wow fadeInLeft col-md-1">
                <div class="d-flex" style="height: 100px;">
                    <div class="vr"></div>
                  </div>
            </div> -->
            <div class="wow fadeInUp offset-md-3 col-md-6 col-sm-7 " data-wow-delay="0.6s">
                <h1>Our Projects</h1>
                <ul>
                  <li>
                    <a routerlink="/" href="/">Home</a>
                  </li>
                  <li>Our Projects</li>
                </ul>
            </div>
        </div> 
        <div class="container bottom-div wow fadeInUp" data-wow-delay="0.5s">
        </div>
    </div>
</section>


<div class="pt-5 pb-5 pos-list">
    <div class="container">
        <h2 class="text-center mb-5">List of Position</h2>
        <div class="row">
            <div class="col-md-8 offset-md-2">
                <ol>
                    <li class="d-flex align-items-center justify-content-center">
                        <ul class="pr-5">
                            <li>Factory Worker</li>
                            <li>Machinist</li>
                            <li>Lathe Machine Operator</li>
                        </ul>
                        <ul class="pl-5">
                            <li>Fabricator</li>
                            <li>Welder</li>
                            <li>Porklift Operator</li>  
                            <li>Machine Operator/Plastic Injection</li>
                        </ul>
                    </li>
                </ol>
            </div>
        </div>
    </div>
</div>

<div class="container pt-5">
    <div class="row">
        <div class="col-md-6 text-center">
            <img src="/assets/images/logo/industries/manufacturing/berain.jpg" class="img-fluid" alt="">
        </div>
        <div class="col-md-6 text-center">
            <img src="/assets/images/logo/industries/manufacturing/bird.png" class="img-fluid" alt="">
        </div>
        <div class="col-md-6 text-center">
            <img src="/assets/images/logo/industries/manufacturing/lagan.png" class="img-fluid" alt="">
        </div>
        <div class="col-md-6 text-center">
            <img src="/assets/images/logo/industries/manufacturing/nidec.jpg" class="img-fluid" alt="">
        </div>
    </div>
</div>